import { Injectable, Inject, DOCUMENT } from '@angular/core';

import { Platform } from '@ionic/angular/lazy';
import { Device } from '@capacitor/device';


@Injectable({ providedIn: 'root' })
export class PlatformService {
  private device: string = null;

  constructor(
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  public isMobile() {
    return (this.platform.is('ios') || this.platform.is('android') && this.platform.is('mobile') && !this.platform.is('mobileweb')) ;
  }

  public isWeb() {
    return this.platform.is('desktop') || this.platform.is('mobileweb');
  }

  public isDesktop() {
    return this.platform.is('desktop');
  }

  public isIos() {
    return this.platform.is('ios') && !this.platform.is('mobileweb');
  }

  public isAndroid() {
    return this.platform.is('android') && !this.platform.is('mobileweb');
  }

  public isIosWeb() {
    return this.platform.is('ios') && this.platform.is('mobileweb');
  }

  /**
   * Detecta si el navegador es Safari (iOS web o escritorio).
   * Safari bloquea window.open() cuando se llama después de operaciones asíncronas (p. ej. tras formatLink).
   * Ionic no expone Safari como plataforma (solo ios, android, desktop, mobileweb), así que usamos
   * el mismo enfoque que Ionic internamente: comprobar userAgent/vendor vía DOCUMENT (Angular).
   */
  public isSafari(): boolean {
    if (this.isIosWeb()) {
      return true;
    }
    if (!this.isDesktop()) {
      return false;
    }
    const win = this.document?.defaultView;
    if (!win?.navigator) {
      return false;
    }
    const nav = win.navigator;
    return nav.vendor === 'Apple Computer, Inc.' ||
      (/Safari/i.test(nav.userAgent) && !/Chrome|Chromium|CriOS/i.test(nav.userAgent));
  }

  public async isAndroid13() {
    console.log('is 13 or higher');
    const deviceInfo = await Device.getInfo();
    const osVersion = typeof deviceInfo.osVersion === 'string' ? parseFloat(deviceInfo.osVersion) : deviceInfo.osVersion;
    console.log('device info: ', deviceInfo);
    return this.isAndroid() && Math.floor(osVersion) >= 13;
  }

  public async isBelowAndroid13() {
    console.log('is below 13');
    const deviceInfo = await Device.getInfo();
    const osVersion = typeof deviceInfo.osVersion === 'string' ? parseFloat(deviceInfo.osVersion) : deviceInfo.osVersion;
    console.log('device info: ', deviceInfo);
    return this.isAndroid() && Math.floor(osVersion) < 13;
  }

  get() {
    if (this.platform.is('desktop') || this.platform.is('mobileweb')) return 'web';
    if (this.platform.is('android') && !this.platform.is('mobileweb')) return 'android';
    if (this.platform.is('ios') && !this.platform.is('mobileweb')) return 'ios';
    return 'Sin definir';
  }

  public async loadDevice() {
    const info = await Device.getInfo();
    this.device = info.model;
  }
  public getDevice() {
    return this.device;
  }
}
